import { IconMap } from "../lib";

export interface NavLink {
  label: string;
  href: string;
  icon: any;
  sublinks?: NavLink[];
}

export const navLinks: NavLink[] = [
  {
    label: "Home",
    href: "#home",
    icon: IconMap.faHome
  },
  {
    label: "About",
    href: "#about",
    icon: IconMap.faHeart,
  },
  {
    label: "Services",
    href: "#services",
    icon: IconMap.faGraduationCap,
  },
  {
    label: "Schemes",
    href: "#schemes",
    icon: IconMap.faGift,
  },
  {
    label: "Contact",
    href: "#contact",
    icon: IconMap.faPhone,
  },
];

